// extracted by mini-css-extract-plugin
export default {"modalFooter":"plain-modal-footer_modalFooter__VgS8Q","hasBorder":"plain-modal-footer_hasBorder__oSmTv","placeHolderShimmer":"plain-modal-footer_placeHolderShimmer__VcdQ+"};